import React, { useState, useMemo } from "react";
import StackedBarChart from "./StackedBarChart";
import PieChart from "./PieChart";
// import { ChartsSectionProps } from '../interface/page.interface';

type TimeRange = "3months" | "6months" | "1year";

const ChartsSection = ({ ots, otsByEquipmentType }: any) => {
  const [timeRange, setTimeRange] = useState<TimeRange>("6months");

  // Procesar datos para el gráfico de barras apiladas
  const monthlyOtsData = useMemo(() => {
    const now = new Date();
    const monthsToInclude =
      timeRange === "3months" ? 3 : timeRange === "6months" ? 6 : 12;

    const monthlyData: { [key: string]: any } = {};
    const monthNames = [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ];

    // Inicializar meses
    for (let i = monthsToInclude - 1; i >= 0; i--) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const monthKey = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}`;
      const monthName = monthNames[date.getMonth()];

      monthlyData[monthKey] = {
        month: monthName,
        emitidas: 0,
        enProceso: 0,
        enReparacion: 0,
        realizadas: 0,
        total: 0,
      };
    }

    // Procesar órdenes de trabajo
    ots.forEach((ot: any) => {
      const otDate = new Date(ot.date);
      const monthKey = `${otDate.getFullYear()}-${String(
        otDate.getMonth() + 1
      ).padStart(2, "0")}`;

      if (monthlyData[monthKey]) {
        switch (ot.statusOtCode) {
          case "STATUS_OT_ISSUED":
            monthlyData[monthKey].emitidas++;
            break;
          case "STATUS_OT_IN_PROGRESS":
            monthlyData[monthKey].enProceso++;
            break;
          case "STATUS_OT_REPAIR":
            monthlyData[monthKey].enReparacion++;
            break;
          case "STATUS_OT_RELATED":
            monthlyData[monthKey].realizadas++;
            break;
        }
        monthlyData[monthKey].total++;
      }
    });

    return Object.values(monthlyData);
  }, [ots, timeRange]);

  return (
    <div className="charts-grid">
      <div className="chart-card">
        <div className="chart-card-header">
          <h3>📋 Órdenes de Trabajo por Estado</h3>
          <div className="chart-filter">
            <button
              className={`filter-btn ${
                timeRange === "3months" ? "active" : ""
              }`}
              onClick={() => setTimeRange("3months")}
            >
              3M
            </button>
            <button
              className={`filter-btn ${
                timeRange === "6months" ? "active" : ""
              }`}
              onClick={() => setTimeRange("6months")}
            >
              6M
            </button>
            <button
              className={`filter-btn ${timeRange === "1year" ? "active" : ""}`}
              onClick={() => setTimeRange("1year")}
            >
              1A
            </button>
          </div>
        </div>
        <div className="chart-container">
          <StackedBarChart data={monthlyOtsData} />
        </div>
      </div>

      <div className="chart-card">
        <div className="chart-card-header">
          <h3>📊 Distribución por Tipo de Equipo</h3>
        </div>
        <div className="chart-container">
          <PieChart data={otsByEquipmentType} />
        </div>
      </div>
    </div>
  );
};

export default ChartsSection;
